export default {
  success: {
    successfully: '{key} bem-sucedido',
    copyToClipboard: 'Copiado para a área de transferência',
    approved: '{key} aprovado',
    processed: '{key} processado com sucesso',
    uploaded: '{key} enviado com sucesso',
    register: 'Registro bem-sucedido, por favor, faça o login',
  },
  warning: {
    rejected: '{key} rejeitado',
    removeFxRateTemplate: 'Atenção: Este modelo será removido dos clientes, instituições e agentes simultaneamente -「{name}」.',
    transferFromIt: 'Tem certeza de que deseja transferir todo o montante restante [Estimado: {amount}] de {from} para {to}?',
    clearBrowserCache: 'Esta ação irá limpar o cache do navegador e restaurá-lo para as configurações padrão a seguir:',
    forcedRefresh: '*Atenção: Esta página será atualizada forçadamente!',
    resetPassword1: 'Um email será enviado para',
    resetPassword2: '{email}',
    resetPassword3: 'para ajudá-lo a recuperar sua conta',
  },
  error: {
    required: 'Campo obrigatório',
    duplicatedBy: 'Não pode ser igual a {target}',
    symbolExisted: 'O par de moedas atual já existe',
    failed: '{key} falhou',
    serverUnavailable: 'Servidor indisponível no momento. Tente novamente mais tarde.',
    uploadFileType: 'Você só pode fazer upload de arquivos {types}',
    uploadFileSize: 'Tamanho não pode exceder {maxSize}MB',
    uploadFailed: 'Falha ao fazer upload',
    underLength: 'Tamanho menor do que o mínimo exigido [{min}]',
    overLength: 'Tamanho maior do que o limite [{max}]',
    decimalOverLength: 'Tamanho maior do que o limite [{precision}, {scale}]',
    underflow: 'Valor menor do que o mínimo exigido [{min}]',
    overflow: 'Valor maior do que o máximo permitido [{max}]',
    invalidMailFormat: 'Formato de email inválido',
    invalidMobileFormat: 'Número de celular inválido',
    notOnlyNumber: 'Deve conter caracteres além de números',
    notOnlyLetter: 'Deve conter caracteres além de letras',
    atLeastOneLowercase: 'Deve conter pelo menos uma letra minúscula',
    atLeastOneUppercase: 'Deve conter pelo menos uma letra maiúscula',
    atLeastOneNumber: 'Deve conter pelo menos um número',
    onlyAlphanumerical: 'Deve ser alfanumérico',
    cannotBeSuperuser: 'Não pode ser um superusuário',
    mustBeSuperuser: 'Deve ser um superusuário',
    mustBeGreaterThan: 'Deve ser maior que {number}',
    ranges: 'Faixa permitida: {min}~{max}',
    lengthLimit: 'Deve ter {length} caracteres de comprimento',
    notSame: 'As senhas não coincidem',
    notBlank: 'Não pode estar em branco',
    containsSpace: 'Não pode conter espaço',
  },
  confirm: {
    title: 'Tem certeza que deseja {action}?',
    resourceNotFoundTitle: 'Recurso não encontrado',
    resourceNotFoundContent: 'Você deseja recarregar a página para obter os recursos mais recentes?',
  },
  modal: {
    add: 'Adicionar {name}',
    edit: 'Editar {name}',
    detail: 'Detalhes de {name}',
  },
  pagination: {
    showTotal: `{start}-{end} de um total de {total} registros`,
  },
  tooltip: {
    settings: 'Essa configuração é armazenada em cache no seu navegador',
  },
  message: {
    itReceiveCheck: 'A verificação da conta de recebimento da instituição foi bem-sucedida.',
    needToCreateUsdReceiveAccount:
      'A verificação da conta de recebimento da instituição falhou, é necessário criar uma conta de recebimento em dólares americanos.',
  },
};
